import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { MdAdd } from 'react-icons/md';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import api from '~/services/api';
import history from '~/services/history';
// Importando componente
import Card from '~/components/Card';
import Input from '~/components/Form/Input';
import Button from '~/components/Form/Button';
import Table from '~/components/Table';
import Load from '~/components/Load';

import { Container, Menus, NewButton } from './styles';

export default function QuestionarioEdit({ match }) {
  const inputRef = useRef(null);
  const [carregar, setCarregar] = useState(false);
  const [idProduto, setIdProduto] = useState(0);
  const [idQuestionario, setIdQuestionario] = useState(0);
  const [respostas, setRespostas] = useState([]);
  const [dado, setDado] = useState([]);
  const [loading, setLoading] = useState(false);

  const getResposta = useCallback(async () => {
    const { idQuizzes } = match.params;

    const response = await api.get(`/pergunta/${idQuizzes}/alternativas`);

    setRespostas(response.data);
  }, [match.params]);

  useEffect(() => {
    getResposta();
  }, [getResposta]);

  useEffect(() => {
    async function getDados() {
      setLoading(true);
      const { id, idQuizzes } = match.params;
      const response = await api.get(`/produto/${id}/perguntas/${idQuizzes}`);

      setIdProduto(id);
      setIdQuestionario(idQuizzes);
      setDado(response.data);
      setLoading(false);
    }
    getDados();
  }, [getResposta, match.params, setIdProduto]);

  // Sistema de edicao de pergunta
  async function handleSubmit(data) {
    try {
      setCarregar(true);
      inputRef.current.setErrors({});
      const schema = Yup.object().shape({
        name: Yup.string().required('Preencha o campo nome'),
        pergunta: Yup.string().required('Preencha o campo pergunta'),
      });
      await schema.validate(data, {
        abortEarly: false,
      });

      await api.put(`/produto/${idProduto}/perguntas/${idQuestionario}`, {
        name: data.name,
        pergunta: data.pergunta,
      });

      toast.success('Pergunta editado com sucesso');
      history.push(`/produto-edit/${idProduto}`);
    } catch (err) {
      setCarregar(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        inputRef.current.setErrors(validationErrors);
      } else {
        toast.error('Error ao editar o pergunta verifique os dados');
      }
    } finally {
      setCarregar(false);
    }
  }

  // Sistema das respostas
  async function handlerStatus(number) {
    try {
      setLoading(true);
      const { idQuizzes } = match.params;
      if (number.length > 1) {
        const res = number.map(async num => {
          const response = await api.delete(
            `/pergunta/${idQuizzes}/alternativas/${num}`
          );
          return response.data;
        });
        const tr = Promise.all(res);
        const df = Promise.resolve(tr);
        df.then(result => {
          if (result[0] !== undefined) {
            toast.success('Resposta excuido com sucesso');
            getResposta();
          }
        });
      } else {
        const response = await api.delete(
          `/pergunta/${idQuizzes}/alternativas/${number}`
        );

        if (response.data) {
          toast.success('Resposta excuido com sucesso');
          getResposta();
        }
      }
    } catch (error) {
      toast.error('Error ao excluir resposta');
      getResposta();
    } finally {
      setLoading(false);
    }
  }

  function handlerEditar(number) {
    const { id, idQuizzes } = match.params;

    history.push(`/resposta-edit/${id}/quizz/${idQuizzes}/res/${number}`);
  }

  function handleCreate() {
    const { id, idQuizzes } = match.params;

    history.push(`/resposta-create/${id}/quizz/${idQuizzes}`);
  }

  // Criando dados da coluna
  const columns = [
    {
      name: 'id',
      label: 'Id',
      options: {
        filter: false,
        sort: true,
        display: false,
      },
    },
    {
      name: 'resposta',
      label: 'Resposta',
      options: {
        filter: true,
        sort: true,
      },
    },
  ];

  if (loading) {
    return <Load />;
  }

  return (
    <Container>
      <h4>Editar Questionário</h4>
      <Card>
        <Form
          ref={inputRef}
          initialData={dado}
          onSubmit={handleSubmit}
          autoComplete="off"
        >
          <Input icon="MdPerson" label="Nome" name="name" type="text" />
          <Input icon="MdPerson" label="Pergunta" name="pergunta" type="text" />
          <Button tamanho="40px" load={carregar}>
            Editar
          </Button>
        </Form>
      </Card>
      <h4>Lista de respostas</h4>
      <Card size={50}>
        <Menus>
          <NewButton onClick={handleCreate}>
            <MdAdd size={16} color="#FFF" />
            Novo
          </NewButton>
        </Menus>
        <Table
          title="Integrações"
          data={respostas}
          columns={columns}
          ds={handlerStatus}
          ed={handlerEditar}
          messages="Você deseja excluir resposta ?"
          st
        />
      </Card>
    </Container>
  );
}

QuestionarioEdit.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
      idQuizzes: PropTypes.string,
    }),
  }).isRequired,
};
